import { useSelector } from 'react-redux';

export const useHasSubmittedWithErrors = () => {
  const hasSubmittedWithErrors = useSelector(state => state.globals.hasSubmittedWithErrors);

  return [hasSubmittedWithErrors];
};

export default useHasSubmittedWithErrors;
